export const cilSwap1 = [
  '40 40',
  `
<path d="M30 33.8573V12.5H27.5V33.9461L22.0451 28.4912L20.2773 30.2588L28.7056 38.6872L37.1338 30.2588L35.3662 28.4912L30 33.8573Z" />
<path d="M12.4556 1.35719L4.02734 9.78554L5.79508 11.5533L11.25 6.09836V27.5H13.75V6.18711L19.1162 11.5533L20.8838 9.78554L12.4556 1.35719Z" />
`,
];
